/* eslint-disable react/jsx-no-bind */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTransition, animated } from "react-spring";
import { useGlobalContent } from "../../hooks";
import Icon from "wonderbly-components/lib/Icon";
import Button from "wonderbly-components/lib/Button";
import Modal from "../Modal";
import SaveForLaterConfirm from "./children/SaveForLaterConfirm";
import SaveForLaterForm from "./children/SaveForLaterForm";

import "./SaveForLater.scss";

const SaveForLater = (props) => {
  const saveForLater = useGlobalContent("saveForLater");

  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const transitions = useTransition(isSubmitted, null, {
    from: { opacity: 0, transform: "translateY(5px)" },
    enter: { opacity: 1, transform: "translateY(0)" },
    leave: { opacity: 0, visibility: "hidden", display: "none" },
  });

  const closeModal = () => {
    setIsOpen(false);
    setIsSubmitted(false);
  };

  return (
    <>
      <Button
        className="SaveForLater__cta"
        onClick={() => setIsOpen(true)}
        unstyled
      >
        <Icon icon="mail" />
        {saveForLater.ctaText}
      </Button>
      <Modal className="SaveForLaterModal" isOpen={isOpen} default>
        {transitions.map((spring) =>
          spring.item ? (
            <animated.div style={spring.props}>
              <SaveForLaterConfirm
                title={saveForLater.confirmationTitle}
                description={saveForLater.confirmationDescription}
                ctaText={saveForLater.confirmationButtonText}
                onHandleClose={closeModal}
              />
            </animated.div>
          ) : (
            <animated.div style={spring.props}>
              <SaveForLaterForm
                productId={props.productId}
                productName={props.productName}
                title={saveForLater.title}
                description={saveForLater.description}
                placeholder={saveForLater.emailPlaceholder}
                ctaText={saveForLater.submitButtonText}
                showOptIn={saveForLater.showOptIn}
                onHandleClose={closeModal}
                onHandleSubmitCallback={() => setIsSubmitted(true)}
              />
            </animated.div>
          )
        )}
      </Modal>
    </>
  );
};

SaveForLater.propTypes = {
  productName: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
};

export default SaveForLater;
